
export const config = {
  id: 'glassmorphism',
  name: 'Glassmorphism',
  icon: 'glass-martini-alt',
  color: 'purple',
  welcomeMessage: "This is a message from the bot.",
  typography: "Poppins, sans-serif",
  description: 'A glassmorphism visual style.',
  preview: 'This is a message from the user.',
  suggestedPrompts: [
    { text: 'Provide a clear overview' },
    { text: 'What are the key features?' },
    { text: 'Simplify this concept' },
  ],
  embedCode: `<script src="chatbot-loader.js"></script>
<script>
window.chatConfig = {
  theme: "glassmorphism",
  color: "#8B5CF6",
  blur: true,
  typography: "Poppins, sans-serif",
  welcomeMessage: "✨ Welcome! I'm your crystal-clear assistant.",
  userId: "user_glass_012",
  chatbotId: "bot_glass_004"
};
</script>`
}; 